import React from 'react'
import Card from './Card.jsx'
import List from './List.jsx'

const renderCard = (page) => {
  return {
    displayName: 'CardRenderer',
    render: (article) => {
      return <Card key={article._meta.id} article={article} page={page} />
    },
  }
}

const renderList = (page) => {
  return {
    displayName: 'listRenderer',
    render: (article) => {
      return <List key={article._meta.id} article={article} page={page} />
    },
  }
}

export { renderList, renderCard }
